import axios from "axios";
// import useSWR from "swr";

class CmsApi {

  constructor(locale = "en-US") {

    this.api = axios.create({
      baseURL: "/api/v1/cms/",
      headers: {
        Locale: locale, 
      },
    });

  }

  async fetchEntityByPath(path) {
    const resourcePath = "entities/path" + encodeURIComponent(path);
    return this.api.get(resourcePath);
  }

  async fetchPreviewByPath(path) {
    const resourcePath = "entities/preview" + encodeURIComponent(path);
    return this.api.get(resourcePath);
  }

  async fetchEntityById(id) {
    const resourcePath = "entities/" + id;
    return this.api.get(resourcePath);
  }

  async fetchEntityBySlug(slug) {
    const resourcePath = "entities/slug/" + slug;
    try {
      let results = await this.api.get(resourcePath);
      return results.data;
    } catch (err) {
      return {};
    }
  }

  async fetchNavComponents(slugs) {
    const resourcePath = "entities/components";
    try {
      let results = await this.api.post(resourcePath, {
        components: slugs,
      });
      return results.data;
    } catch (err) {
      return {};
    }
  }

  async fetchEntityByContentType(type, limit, page, tag, sortBy) {
    let resourcePath = `entities?type=${type}&withElements=blog_detail`;
    if (tag) resourcePath += `&tag=${tag}`;
    if (limit) resourcePath += `&limit=${limit}`;
    if (sortBy) resourcePath += `&sortByElementDesc=${sortBy}`;
    if (page) resourcePath += `&page=${page}`;
    return this.api.get(resourcePath);
  }
}

export default CmsApi;
